// ProjectStatus.jsx
import React from "react";
import { projectAtomList } from "../../atoms";
import { useAtom } from "jotai";
import ProgressBarContainer from "../progressBar/progressBarContainer";
import { withRouter } from "react-router-dom";

const ProjectStatus = (props) => {
  const [currentProject, setCurrentProject] = useAtom(projectAtomList);
  const { projectId } = props?.match?.params
  return (
    <>
      {projectId && !currentProject?.projectStatus?.projectName  ? (
        <div className="stickyProgressBar">
          <div className="d-flex justify-content-between">
            <se-skeleton height="20px" style={{ width: "33%" }}></se-skeleton>
            <se-skeleton height="20px" style={{ width: "33%" }}></se-skeleton>
            <se-skeleton height="20px" style={{ width: "33%" }}></se-skeleton>
          </div>
        </div>
      ) : (
        
        currentProject?.projectStatus?.projectName && (
          <ProgressBarContainer
            projectStatusData={currentProject?.projectStatus}
          />
        )
      )}
    </>
  );
};

export default withRouter(ProjectStatus);
